'use server'

import { Professional } from '../common/interfaces/professional.interface'
import { PartnerPayoutScheduleType } from '../common/interfaces/partner.interface'
import { apiRequest, ApiResponse } from '../request'

export async function getProfessionals(
    organizationId?: number
): Promise<ApiResponse<Professional[]>> {
    return apiRequest<Professional[]>('professionals', {
        params: organizationId ? { organizationId } : {},
    })
}

export async function getProfessional(
    id: number
): Promise<ApiResponse<Professional>> {
    return apiRequest<Professional>(`professionals/${id}`, {})
}

export async function getProfessionalsByOrganization(
    organizationId: number,
    params?: {
        page?: number
        limit?: number
        search?: string
    },
): Promise<ApiResponse<Professional[]>> {
    const queryParams: Record<string, any> = {}
    if (params?.page) queryParams.page = params.page
    if (params?.limit) queryParams.limit = params.limit
    if (params?.search) queryParams.search = params.search
    return apiRequest<Professional[]>(`professionals/organization/${organizationId}`, {
        params: queryParams,
    })
}

export async function createProfessional(data: {
    name: string
    email?: string
    phoneNumber?: string
    whatsAppNumber?: string
    phone2?: string
    phone3?: string
    formation?: string
    scholarLevel?: string
    document?: string
    documentType?: string
    registrationNumber?: string
    councilName?: string
    createUser?: boolean
    titles?: string[]
    qualifications?: string[]
    street?: string
    number?: string
    complement?: string
    neighborhood?: string
    city?: string
    state?: string
    zipCode?: string
    country?: string
    organizationId: number
    specialtyIds?: number[]
    specialtyNames?: string[]
    specialties?: {
        specialtyId?: number
        specialtyName?: string
        consultationPrice?: number
        maxDiscount?: number
    }[]
    roleId?: number
    hospitalIds?: number[]
    establishmentIds?: number[]
    partnerId?: number | null
    payoutScheduleType?: PartnerPayoutScheduleType
    payoutFixedDay?: number | null
    payoutDaysAfterAppointment?: number | null
}): Promise<ApiResponse<Professional>> {
    return apiRequest<Professional>('professionals', { data }, 'post')
}

export async function updateProfessional(
    id: number,
    data: {
        name?: string
        email?: string
        phoneNumber?: string
        whatsAppNumber?: string
        phone2?: string
        phone3?: string
        formation?: string
        scholarLevel?: string
        document?: string
        documentType?: string
        registrationNumber?: string
        councilName?: string
        createUser?: boolean
        titles?: string[]
        qualifications?: string[]
        street?: string
        number?: string
        complement?: string
        neighborhood?: string
        city?: string
        state?: string
        zipCode?: string
        country?: string
        organizationId?: number
        specialtyIds?: number[]
        specialtyNames?: string[]
        specialties?: {
            specialtyId?: number
            specialtyName?: string
            consultationPrice?: number
            maxDiscount?: number
        }[]
        roleId?: number
        hospitalIds?: number[]
        establishmentIds?: number[]
        partnerId?: number | null
        payoutScheduleType?: PartnerPayoutScheduleType
        payoutFixedDay?: number | null
        payoutDaysAfterAppointment?: number | null
    }
): Promise<ApiResponse<Professional>> {
    return apiRequest<Professional>(`professionals/${id}`, { data }, 'patch')
}

export async function uploadProfessionalPhoto(
    id: number,
    file: File
): Promise<ApiResponse<{ id: number; name: string; photoUrl: string }>> {
    const formData = new FormData()
    formData.append('photo', file)
    return apiRequest<{ id: number; name: string; photoUrl: string }>(
        `professionals/${id}/photo`,
        { data: formData, formData: true },
        'post'
    )
}

export async function deleteProfessional(
    id: number
): Promise<ApiResponse<void>> {
    return apiRequest<void>(`professionals/${id}`, {}, 'delete')
}
